// Constants for this module.

/**
 * The SPA route the IdP redirects back to after authorize. The path is registered as an allowed
 * callback URL on the IdP tenant and is masked in the WAF logs, so its value must not change
 * without updating both.
 */
export const IDP_CALLBACK_PATH = "/auth0/callback";

/**
 * OAuth / OIDC error codes the app reacts to.
 */
export const IdPErrorCode = {
  LOGIN_REQUIRED: "login_required",
} as const;
